<template>
  <form @submit.prevent="submit">
    <div class="order-operation-notes-modal modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Update Terminology</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Key">
          <b-input :value="terminology.key" name="key" disabled />
        </b-field>
        <b-field label="Value">
          <b-input v-model="form.value" name="value" />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">
          Cancel
        </b-button>
        <b-button native-type="submit" type="is-info" :loading="loading">
          Update
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { TerminologyService } from "@/services/terminology.service";

export default {
  props: {
    terminology: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    form: {
      value: ""
    },
    loading: false
  }),
  created() {
    this.form.value = this.terminology.value;
  },
  methods: {
    close() {
      this.$parent.close();
    },
    async submit() {
      this.loading = true;

      try {
        const data = await TerminologyService.update(
          this.terminology.id,
          this.form
        ).then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "Terminology has been updated.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("submit", data);
        this.close();
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Terminology/TerminologyFormUpdate.vue